var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPillBottleRebrand = function SvgPillBottleRebrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Pill-Bottle-rebrand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M20.4 34.823H1.177A1.167 1.167 0 0 1 0 33.646V11.575c0-.807.445-1.614 1.111-2.067l3.096-1.91c.378-.222.592-.592.592-1.037V3.622h12.003v2.94c0 .444.214.806.593 1.037l3.095 1.91c.733.452 1.112 1.185 1.112 2.066v17.23l-1.178 6.034-.016-.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M18.556 1.185V4.19c0 .379-.288.593-.593.593H3.614c-.379 0-.593-.288-.593-.593V1.185C3.021.52 3.54 0 4.2 0h13.18c.658 0 1.177.519 1.177 1.185"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F1F",
    d: "M18.556 29.373H0V14.365h21.577v14.423z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M11.41 2.437v2.436h-1.177V2.437c0-.362.288-.593.593-.593.304 0 .592.214.592.593zM8.99 2.437v2.437H7.812V2.437c0-.362.289-.593.593-.593.288-.074.593.214.593.593zM6.553 2.437v2.437H5.376V2.437c0-.362.288-.593.592-.593.38-.074.593.214.593.593zM13.773 2.437v2.437h-1.177V2.437c0-.362.288-.593.592-.593.379-.074.593.214.593.593zM16.21 2.437v2.437h-1.178V2.437c0-.362.288-.593.593-.593.288-.074.593.214.593.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D24E23",
    d: "M18.556 29.373H11.27V14.365h10.315v15.008h-3.029"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M31.291 33.283c-.14 1.54-1.473 2.651-2.939 2.651h-3.606l-1.177-3.013 1.177-3.013h2.94L31.29 33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F1F",
    d: "M24.664 29.966V36h-3.606c-1.687 0-3.03-1.325-3.03-3.005s1.326-3.03 3.03-3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "m32.098 25.915-1.4 3.458-2.864.807-2.577-2.577a2.95 2.95 0 0 1-.659-3.244c.445-1.103 1.54-1.844 2.791-1.844.807 0 1.54.288 2.132.881l2.577 2.511z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F1F",
    d: "M34.6 32.69a3.016 3.016 0 0 1-4.264 0l-2.577-2.576 4.265-4.264 2.576 2.576a3.016 3.016 0 0 1 0 4.265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.027 21.067c0 .946-.659 1.695-1.466 1.695s-1.473-.732-1.473-1.695.658-1.705 1.473-1.705 1.466.807 1.466 1.705M17.444 21.067c0 .946-.666 1.695-1.473 1.695s-1.466-.732-1.466-1.695.659-1.705 1.466-1.705c.88 0 1.473.807 1.473 1.705M10.891 18.054c0 1.037-.732 1.844-1.613 1.844s-1.54-.807-1.54-1.844c0-1.038.733-1.844 1.54-1.844s1.613.806 1.613 1.843M14.868 18.054c0 1.037-.733 1.844-1.614 1.844-.88 0-1.614-.807-1.614-1.844 0-1.038.733-1.844 1.614-1.844.88 0 1.614.806 1.614 1.843M13.987 27.406c.955-.38 1.54-1.252 1.54-2.207 0-.807-.38-1.54-1.112-2.272-.214-.222-1.325-1.325-2.132-2.206-.519-.519-1.4-.593-1.918-.074l-.075.074c-.806.88-1.918 1.984-2.132 2.206-.732.733-1.111 1.465-1.111 2.272 0 .955.593 1.918 1.54 2.206 1.02.371 2.206-.148 2.65-1.11.519.954 1.704 1.399 2.725 1.11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Pill-Bottle-rebrand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35.49v36H0z"
  })))));
};
export default SvgPillBottleRebrand;